(() => {
  if (!window.customElements) return;
  if (!customElements.get('sb-brand-fan')) customElements.define('sb-brand-fan', class extends HTMLElement {
    connectedCallback() {
      this._controller?.abort();
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this._reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this._active = true;
      this._schedule = () => {
        if (!this._active || this._frame) return;
        this._frame = requestAnimationFrame(() => { this._frame = 0; this.update(); });
      };
      // Horizon scrolls .page-wrapper, not always window. Capture nested scrolls too.
      addEventListener('scroll', this._schedule, { passive: true, capture: true, signal });
      addEventListener('resize', this._schedule, { passive: true, signal });
      this._reduce.addEventListener('change', () => this.update(), { signal });
      this._observer = new IntersectionObserver(entries => {
        this._active = entries[0].isIntersecting;
        if (this._active) this._schedule();
      }, { rootMargin: '120px 0px' });
      this._observer.observe(this);
      this._motionObserver = new MutationObserver(() => this.update());
      this._motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-sb-motion'] });
      this.update();
    }
    update() {
      if (this.dataset.motion !== 'true' || this._reduce.matches || document.documentElement.dataset.sbMotion === 'false') {
        this.style.setProperty('--sb-fan-progress', '1');
        return;
      }
      const rect = this.getBoundingClientRect();
      const raw = Math.min(1, Math.max(0, (innerHeight * .9 - rect.top) / (innerHeight * .56)));
      const progress = raw * raw * (3 - 2 * raw);
      this.style.setProperty('--sb-fan-progress', progress.toFixed(4));
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._motionObserver?.disconnect();
      cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
  });

  if (!customElements.get('sb-battery-charge')) customElements.define('sb-battery-charge', class extends HTMLElement {
    connectedCallback() {
      this._controller?.abort();
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this._reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this._active = true;
      this._schedule = () => {
        if (!this._active || this._frame) return;
        this._frame = requestAnimationFrame(() => { this._frame = 0; this.update(); });
      };
      addEventListener('scroll', this._schedule, { passive: true, capture: true, signal });
      addEventListener('resize', this._schedule, { passive: true, signal });
      this._reduce.addEventListener('change', () => this.update(), { signal });
      this._observer = new IntersectionObserver(entries => {
        this._active = entries[0].isIntersecting;
        if (this._active) this._schedule();
      }, { rootMargin: '120px 0px' });
      this._observer.observe(this);
      this._motionObserver = new MutationObserver(() => this.update());
      this._motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-sb-motion'] });
      this.update();
    }
    update() {
      if (this.dataset.motion !== 'true' || this._reduce.matches || document.documentElement.dataset.sbMotion === 'false') {
        this.style.setProperty('--sb-battery-progress', '1');
        return;
      }
      const rect = this.getBoundingClientRect();
      const raw = Math.min(1, Math.max(0, (innerHeight * .86 - rect.top) / (innerHeight * .38)));
      this.style.setProperty('--sb-battery-progress', raw.toFixed(4));
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._motionObserver?.disconnect();
      cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
  });
})();
